<template>
    <button
        class="flex items-center justify-center gap-1 px-3 py-2 text-md border rounded"
        :class="`${bgColor} ${textColor}`"
        @click.stop="$emit('onClick')"
    >
        <slot name="icon" />
        {{ text }}
    </button>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'Button',
        },

        color: {
            type: String,
            default: 'white',
        },
    },

    computed: {
        textColor() {
            return this.color === 'white' ? 'text-black' : 'text-white';
        },

        bgColor() {
            return this.color === 'white' ? `bg-${this.color}` : `bg-${this.color}-500`;
        },
    },
};
</script>

<style></style>
